module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/file-text-2c62b21f913761cf375834b8e704e4be.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/file-text.svg
// module id = 0ohP
// module chunks = 24